function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import Vue from 'vue';
import omit from 'object.omit';
import Icon from '../icon';
import Modal from './modal.js';
var confirms = new Set();
var defaultProps = {
  type: 'success',
  prefixCls: 'ux-confirm',
  okType: 'primary',
  iconType: 'question_circle',
  maskClosable: false,
  closable: false,
  width: '416px',
  okCancel: true,
  okText: '确定',
  cancelText: '取消',
  theme: 'light',
  dangerouslySetInnerHTML: false
};

function modalConfrim(props) {
  return new Promise(function (resolve, reject) {
    var container = document.createElement('div');
    document.body.appendChild(container);
    var vm = new Vue({
      components: {
        Modal: Modal,
        Icon: Icon
      },
      data: function data() {
        return {
          attrs: null,
          listeners: null
        };
      },
      created: function created() {
        confirms.add(this);
      },
      destroyed: function destroyed() {
        confirms.delete(this);
        var parentNode = container.parentNode;

        if (parentNode) {
          parentNode.removeChild(container);
        }
      },
      methods: {
        onModalEnter: function onModalEnter() {
          var okBtnRef = this.$refs.okBtnRef;

          if (okBtnRef) {
            okBtnRef.focus();
          }
        }
      },
      render: function render() {
        var h = arguments[0];
        var attrs = this.attrs,
            listeners = this.listeners;

        if (!attrs) {
          return null;
        }

        var prefixCls = attrs.prefixCls,
            type = attrs.type,
            iconType = attrs.iconType,
            title = attrs.title,
            content = attrs.content,
            okCancel = attrs.okCancel,
            cancelText = attrs.cancelText,
            okType = attrs.okType,
            okText = attrs.okText,
            dangerouslySetInnerHTML = attrs.dangerouslySetInnerHTML;
        var bindProps = omit(attrs, ['prefixCls', 'type', 'iconType', 'okCancel', 'title', 'content', 'okType', 'okText', 'dangerouslySetInnerHTML']);
        bindProps.dialogClass = [prefixCls, "".concat(prefixCls, "-").concat(type), bindProps.dialogClass];
        var cancelBtn = okCancel ? h("button", {
          "attrs": {
            "htmlType": "button"
          },
          "class": "ux-btn",
          "on": {
            "click": listeners.cancel
          }
        }, [cancelText]) : null;
        var modalContent = dangerouslySetInnerHTML ? h("div", {
          "class": "".concat(prefixCls, "-content"),
          "domProps": _objectSpread({}, {
            innerHTML: content
          })
        }) : h("div", {
          "class": "".concat(prefixCls, "-content")
        }, [content]);
        return h("modal", {
          "props": _objectSpread({}, bindProps),
          "on": _objectSpread({}, _objectSpread({}, listeners))
        }, [h("div", {
          "class": "".concat(prefixCls, "-body-wrapper")
        }, [h("div", {
          "class": "".concat(prefixCls, "-body")
        }, [h("icon", {
          "attrs": {
            "type": iconType
          }
        }), h("span", {
          "class": "".concat(prefixCls, "-title")
        }, [title]), modalContent]), h("div", {
          "class": "".concat(prefixCls, "-btns")
        }, [cancelBtn, h("button", {
          "ref": "okBtnRef",
          "attrs": {
            "htmlType": "button"
          },
          "class": ['ux-btn', "ux-btn-".concat(okType)],
          "on": {
            "click": listeners.ok
          }
        }, [okText])])])]);
      }
    }).$mount();

    var attrs = _objectSpread({}, defaultProps, {}, props, {
      value: true,
      hideFooter: true,
      getContainer: function getContainer() {
        return container;
      }
    });

    function close() {
      attrs.value = false;
    }

    var listeners = {
      'after-close': function afterClose() {
        vm.$destroy();
      },
      cancel: function cancel() {
        close();
        reject();
      },
      ok: function ok() {
        close();
        resolve();
      }
    };
    vm.attrs = attrs;
    vm.listeners = listeners;
  });
}

modalConfrim.config = function () {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  defaultProps = _objectSpread({}, defaultProps, {}, props);
};

modalConfrim.destroy = function () {
  confirms.forEach(function (vm) {
    var nVm = vm;
    nVm.attrs.value = false;
  });
};

export default modalConfrim;